export default __webpack_public_path__ + "static/8-41adb1c2655e950eaf8595613e5e517b.jpg";